<template>
<div>
    <button @click="getItems" class="btn btn-sm btn-success mb-3">Обновить</button>
    <ul v-if="item">
         <li v-for="(i,k) in item" :key="k">
              <h4>{{i.id}} # {{i.title}}</h4>
                <ul v-if="i.child.length">
                    <li v-for="child in  i.child" :key="child.id">
                                 <h6>{{child.id}} # {{child.title}}</h6>
                          <tags 
                                :feature_id="child.id" 
                                :urlGet="`products/feat/values?id=${id}`"
                                :urlUpdate="`products/feat/update?id=${id}`"
                                :urlPush="`products/feat/push?id=${id}`"
                              v-model="child.value"/>       
                      </li>
                </ul>
          </li>
    </ul>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

export default {
  props: ["id"],
  data: () => ({
    item:null,
    cardLink:'products/feat/list'
  }),
   created(){
     this.getItems();
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {},
    async removeItem() {},
    async getItems(){
      this.item = null;
       this.item = await this.cardContent(this.cardLink, this.id);
    }
  },
};
</script>
<style>
</style>
